import React from 'react';
import { IconRightArrow } from 'src/content/icons';
import { Button } from '@framework-controls/core';
import classNames from 'classnames';
import css from './AddSkipButton.module.scss';

export interface IProps {
    id: string;
    message: React.ReactNode;
    variant?: string | 'primaryBtn';
    noArrow?: boolean;
    isDisabled?: boolean;
    handler: (e: any) => void;
    tooltip?: string;
    longLitFlag?: string;
    theme?: string;
}

const AddSkipButton = (props: IProps) => {
    let btnLitClasses = [css.btnLit];

    const arrowStyles = classNames(
        css.arrowIcon,
        {
            [css.arrowIconLM]: props.theme === 'lexusMonogram',
            [css.arrowIconCV]: props.theme === 'chevrolet',
            [css.arrowIconNissan]: props.theme === 'nissan',
            [css.arrowIconMazda]: props.theme === 'mazda',
        },
    );

    // by default set arrowDiv to null, but set so a ReactElement is a valid value for the var.
    let arrowDiv: React.ReactElement | null = null;
    // if not noArrow (false) build the normal forwards arrow, arrovDiv reactElement.
    if (!props.noArrow) {
        arrowDiv = (
            <div className={arrowStyles}>
                <IconRightArrow style={{ margin: 'auto' }} />
            </div>);
    }

    // set button variant based on passed in prop.
    // If nothing passed in, then default to primaryBtn
    let btnVariant = props.variant;
    if (!btnVariant) {
        btnVariant = 'primaryASBtn';
    }
    if (btnVariant === 'MFABtn') {
        btnLitClasses = [css.btnLitMFA];
    }

    if (props.theme === 'chevrolet') {
        btnLitClasses = [css.btnLitCV];
    }

    if (props.theme === 'bmw') {
        btnLitClasses = [css.btnLitBMW];
    }

    if (props.theme === 'mazda') {
        btnLitClasses = [css.btnLitMazda];
    }

    let btnToolTip = '';
    if (!props.isDisabled) {
        btnToolTip = props.tooltip ? props.tooltip : '';
    }

    // Long literals require different rems.
    if (props.longLitFlag) {
        switch (props.longLitFlag) {
            case 'A': btnLitClasses.push(css.longLitA);
                break;
            case 'B': btnLitClasses.push(css.longLitB);
                break;
            default: btnLitClasses.push(css.longLitA);
        }
    }

    return (
        <Button
            id={props.id + 'btn'}
            variant={btnVariant}
            type={'custom'}
            disabled={props.isDisabled}
            onClick={props.handler}
            // tooltip={!props.isDisabled ? props.tooltip : ''}
            tooltip={btnToolTip}
        >
            <div
                className={btnLitClasses.join(' ')}>{props.message}</div>
            {arrowDiv}
        </Button>
    );
};

export default AddSkipButton;
